
export function FormatCurrency({ amount = 0 }) {

    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        currencySign: 'accounting',
    }).format(amount).replace("$", "₵")

    return (
        <div>{currency}</div>
    )
}

export default FormatCurrency